import React, { createContext } from 'react';
import axios from 'axios';
export const apiContext = createContext()

let hasAuthInterceptor = false;

export function clearAuthSession() {
    localStorage.removeItem('token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('keycloak_access_token');
    localStorage.removeItem('keycloak_id_token');
    delete axios.defaults.headers.common['Authorization'];
}

export function getAuthToken() {
    return localStorage.getItem('token');
}

export function setAuthSession(token, userId) {
    if (!token || !userId) {
        throw new Error('Data login tidak lengkap.');
    }

    const tokenValue = String(token);
    const userIdValue = String(userId);

    localStorage.setItem('token', tokenValue);
    localStorage.setItem('user_id', userIdValue);
    setAuthHeader(tokenValue);

    if (localStorage.getItem('token') !== tokenValue) {
        throw new Error('Token login gagal disimpan di browser.');
    }
}

function setAuthHeader(token) {
    axios.defaults.headers.common['Accept'] = 'application/json';

    if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
}

function setupAuthInterceptor() {
    if (hasAuthInterceptor) {
        return;
    }

    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error?.response?.status;
            const pathname = window.location.pathname;
            const isAuthPage = pathname === '/login' || pathname === '/login/keycloak/callback' || pathname === '/logout';

            if (status === 401 && !isAuthPage) {
                clearAuthSession();
                window.location.assign('/login');
            }

            return Promise.reject(error);
        }
    );

    hasAuthInterceptor = true;
}

function Api(props) {
    const API_URL = process.env.REACT_APP_API_URL;
    const token = getAuthToken();
    axios.defaults.baseURL = API_URL;
    setAuthHeader(token);
    setupAuthInterceptor();

    return (
        <apiContext.Provider
            value={{
                axios, API_URL
            }}>
            {props.children}
        </apiContext.Provider>
    )
}
export default Api;
